import hcRequest from "@/helper/hc-request";
import urlcontext from '@/services/conf/axios.urlcontext';
import httphelper from '@/services/conf/httphelper'

export default {
    
    getConfiguration(){

        /*Se crea la instancia de hcRequest */
        let apiCatalogoConf = new hcRequest()
        /*Base de la api*/
        apiCatalogoConf.base = urlcontext.APP_CATALOGO_API
        /* Se configura los headers Headers*/
        apiCatalogoConf.headers = httphelper.getCoreHeaders()
        /*Autorizacion */
        apiCatalogoConf.authorization = httphelper.getToken()
        
        return apiCatalogoConf
    }

}    
